const useCookies = (): string => {
  // TODO: to be implemented
  const cookies = '';
  return cookies;
};

export default useCookies;
